import { Colors } from "@/enums/Colors";
import { Typography } from "@mui/material";

export const PageNavBarTitle = ({ title }: { title: string }) => {
  return (
    <Typography variant="h5" sx={{ fontWeight: 600, color: Colors.BLACK }}>
      {title}
    </Typography>
  );
};
